import React from 'react';
import { TCN } from '../../tcn/ui-kit/tokens';

/**
 * Stacked-block section header — big iOS-style title + optional subtitle.
 *
 * The transverse pattern for TCN modules: one module = one scrollable screen,
 * sub-views stacked as big-title blocks instead of internal tabs (audit §0.1).
 * Mirrors the local SectionHeader used on the Today page (M1).
 *
 * Props:
 *   - title: string
 *   - subtitle?: string
 *   - trailing?: ReactNode — rendered at the end of the title row (e.g. an add button)
 */
const SectionHeader = ({ title, subtitle, trailing }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: 12,
    }}
  >
    <div style={{ minWidth: 0 }}>
      <div
        style={{
          fontSize: 20,
          fontWeight: 700,
          color: TCN.text,
          letterSpacing: '-0.02em',
          lineHeight: 1.2,
        }}
      >
        {title}
      </div>
      {subtitle && (
        <div style={{ fontSize: 13, color: TCN.textDim, marginTop: 2 }}>{subtitle}</div>
      )}
    </div>
    {trailing != null && <div style={{ flexShrink: 0 }}>{trailing}</div>}
  </div>
);

export default SectionHeader;
